import {
  createStyles, Switch, Theme, withStyles,
} from '@material-ui/core';

const SwitchAction = withStyles(({ palette }: Theme) => createStyles({
  switchBase: {
    color: '#FFF',
    '&$checked': {
      color: '#FFF',
    },
    '&$checked + $track': {
      backgroundColor: palette.studio.action,
      opacity: 1,
    },
  },
  checked: {},
  track: {
    background: palette.studio.track,
    opacity: 1,
  },
}))(Switch);

export default SwitchAction;
